import { Hidden, Paragraph } from 'applaus-ui-kit'
import { motion } from 'framer-motion'
import { ButtonBack } from '../../../../components/buttonBack/ButtonBack'
import { history } from '../../../../routes/services/history'
import * as S from './PrivacyPolicy.styles'

export const PrivacyPolicy = () => {
  return (
    <motion.div animate={{ opacity: [0, 1], transition: { duration: 0.5 } }}>
      <S.Container>
        <Hidden tablet desktop>
          <ButtonBack
            title="Política de privacidade"
            click={() => history.push('/terms')}
          />
        </Hidden>

        <S.Wrapper>
          <S.Title>Política de privacidade</S.Title>

          <Paragraph variant="regular">
            A Applaus (&quot;nós&quot;, &quot;nossa&quot; ou &quot;plataforma&quot;) valoriza a privacidade e a proteção dos dados pessoais de seus usuários. Esta Política de Privacidade descreve, de forma clara e transparente, como coletamos, utilizamos, armazenamos, compartilhamos e protegemos as informações fornecidas por você ao utilizar nossos serviços, em conformidade com a Lei Geral de Proteção de Dados Pessoais (Lei nº 13.709/2018 – LGPD) e demais normas aplicáveis.
          </Paragraph>

          <Paragraph variant="regular">
            Ao acessar ou utilizar a plataforma Applaus, você declara ter lido e compreendido esta Política, concordando com as práticas nela descritas. Recomendamos a leitura atenta deste documento, bem como dos nossos Termos de Uso, que juntos regem a relação entre você e a Applaus.
          </Paragraph>

          <Paragraph variant="large" type="bold">
            1. Quais dados coletamos
          </Paragraph>

          <Paragraph variant="regular">
            Para viabilizar o funcionamento da plataforma e a prestação dos nossos serviços, podemos coletar diferentes categorias de dados, entre elas:
          </Paragraph>

          <Paragraph variant="regular">
            <S.List>
              <li>Dados de identificação e cadastro, como nome, e-mail, telefone e demais informações fornecidas no momento do registro ou uso da conta;</li>
              <li>Dados de acesso e navegação, como endereço IP, tipo de dispositivo, navegador utilizado e páginas ou funcionalidades acessadas dentro da plataforma;</li>
              <li>Dados de interação, como preferências, histórico de uso e conteúdos gerados ou consumidos dentro da Applaus;</li>
              <li>Dados de pagamento e transações, quando aplicável à contratação de serviços pagos, sempre processados com os cuidados de segurança exigidos pela legislação;</li>
              <li>Dados obtidos por meio de cookies e tecnologias similares, conforme detalhado em nossa Declaração de Cookies;</li>
              <li>Outras informações fornecidas voluntariamente por você em contato com nossos canais de suporte ou atendimento.</li>
            </S.List>
          </Paragraph>
          <Paragraph variant="regular">
            A coleta se limita ao que é necessário para as finalidades descritas nesta Política, observando os princípios da necessidade, adequação e transparência previstos na LGPD.
          </Paragraph>

          <Paragraph variant="large" type="bold">2. Como utilizamos seus dados</Paragraph>
          <Paragraph variant="regular">As informações coletadas são utilizadas para:</Paragraph>

          <Paragraph variant="regular">
            <S.List>
              <li>Criar, manter e gerenciar sua conta e o acesso aos serviços da Applaus;</li>
              <li>Personalizar sua experiência e aprimorar as funcionalidades oferecidas pela plataforma;</li>
              <li>Processar pagamentos e cumprir obrigações contratuais, quando aplicável;</li>
              <li>Enviar comunicações operacionais, como atualizações de serviço, avisos de segurança e respostas a solicitações de suporte;</li>
              <li>Enviar comunicações de marketing e conteúdos promocionais, sempre que você tiver consentido com esse tipo de contato, com opção de cancelamento a qualquer momento;</li>
              <li>Realizar análises estatísticas e de desempenho, com o objetivo de aprimorar a plataforma e a experiência dos usuários;</li>
              <li>Prevenir fraudes, garantir a segurança da plataforma e cumprir obrigações legais ou regulatórias aplicáveis.</li>
            </S.List>
          </Paragraph>

          <Paragraph variant="large" type="bold">3. Compartilhamento de dados</Paragraph>
          <Paragraph variant="regular">
            A Applaus não vende dados pessoais a terceiros. O compartilhamento de informações ocorre apenas quando necessário para a execução dos serviços ou por exigência legal, incluindo, entre outras hipóteses:
          </Paragraph>
          <Paragraph variant="regular">
            <S.List>
              <li>Prestadores de serviço e parceiros que auxiliam na operação da plataforma (como hospedagem, processamento de pagamentos e suporte técnico), sempre vinculados a obrigações contratuais de confidencialidade e segurança;</li>
              <li>Autoridades públicas, quando exigido por lei, ordem judicial ou determinação de órgão regulador competente;</li>
              <li>Terceiros envolvidos em eventual reorganização societária, fusão ou aquisição, sempre resguardando o mesmo nível de proteção previsto nesta Política.</li>
            </S.List>
          </Paragraph>
          <Paragraph variant="regular">
            Em qualquer hipótese de compartilhamento, adotamos medidas para garantir que os dados sejam tratados com a mesma diligência e nível de proteção descritos neste documento.
          </Paragraph>

          <Paragraph variant="large" type="bold">4. Cookies e tecnologias similares</Paragraph>
          <Paragraph variant="regular">
            Utilizamos cookies e ferramentas semelhantes para viabilizar o funcionamento da plataforma, entender como os usuários interagem com nossos serviços e personalizar conteúdos e anúncios. Você pode gerenciar suas preferências de cookies a qualquer momento por meio das configurações do seu navegador ou dos mecanismos disponibilizados na própria plataforma. Mais detalhes estão disponíveis em nossa Declaração de Cookies.
          </Paragraph>

          <Paragraph variant="large" type="bold">5. Armazenamento e segurança</Paragraph>
          <Paragraph variant="regular">
            Adotamos medidas técnicas e organizacionais compatíveis com as práticas de mercado para proteger seus dados pessoais contra acessos não autorizados, perda, alteração ou destruição indevida. Os dados são armazenados pelo tempo necessário ao cumprimento das finalidades descritas nesta Política ou conforme exigido por obrigações legais e regulatórias, sendo eliminados ou anonimizados de forma segura ao final desse período.
          </Paragraph>
          <Paragraph variant="regular">
            Caso ocorra qualquer incidente de segurança que possa acarretar risco relevante aos titulares dos dados, a Applaus adotará as providências cabíveis, incluindo a comunicação aos usuários afetados e, quando aplicável, à Autoridade Nacional de Proteção de Dados (ANPD), em conformidade com a legislação vigente.
          </Paragraph>

          <Paragraph variant="large" type="bold">6. Seus direitos como titular de dados</Paragraph>
          <Paragraph variant="regular">
            Nos termos da LGPD, você pode, a qualquer momento, solicitar:
          </Paragraph>
          <Paragraph variant="regular">
            <S.List>
              <li>Confirmação da existência de tratamento e acesso aos seus dados pessoais;</li>
              <li>Correção de dados incompletos, inexatos ou desatualizados;</li>
              <li>Anonimização, bloqueio ou eliminação de dados desnecessários ou tratados em desconformidade com a lei;</li>
              <li>Portabilidade dos dados a outro fornecedor de serviço, mediante requisição expressa;</li>
              <li>Revogação do consentimento e informações sobre as consequências dessa decisão;</li>
              <li>Informações sobre entidades com as quais seus dados foram compartilhados. </li>
            </S.List>
          </Paragraph>
          <Paragraph variant="regular">
            Para exercer qualquer um desses direitos, entre em contato através dos canais indicados na seção 8 deste documento. Responderemos às solicitações dentro dos prazos estabelecidos pela legislação aplicável.
          </Paragraph>

          <Paragraph variant="large" type="bold">7. Alterações desta Política</Paragraph>
          <Paragraph variant="regular">
            Esta Política de Privacidade pode ser atualizada periodicamente para refletir mudanças em nossas práticas, em nossos serviços ou na legislação aplicável. Recomendamos a consulta regular a este documento. Alterações relevantes serão comunicadas por meio da plataforma ou de outros canais apropriados, e a versão mais recente estará sempre disponível para consulta.
          </Paragraph>

          <Paragraph variant="large" type="bold">8. Como falar conosco</Paragraph>
          <Paragraph variant="regular">
            Se você tiver dúvidas, solicitações ou quiser exercer seus direitos relacionados a esta Política de Privacidade, entre em contato com nosso canal oficial de atendimento através dos meios disponibilizados na plataforma Applaus. Faremos o possível para responder de forma clara e dentro dos prazos legais aplicáveis.
          </Paragraph>
        </S.Wrapper>
      </S.Container>
    </motion.div>
  )
}
